<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e91">SWEETWATER <br/><b>gap</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hunt_9781595542595_epub_c3_r1.vue?79c2286d